module.exports = __webpack_public_path__ + "img/6.f0d31d0b.png";